module.exports = __webpack_public_path__ + "img/about-3.d2033dcc.jpg";